import { CreateReportsModal } from './reports-list-actions-modal'

export const ReportsList = () => {
  return (
    <div className="p-12 bg-white content-container">
      <div className="lg:flex-row lg:justify-between gap-2">
        <div>
          <h3>
            <span className="tracking-wider font-bold text-xl">Reports</span>
          </h3>
          <p>
            <span className="tracking-wider font-light">
              Check the list of available reports
            </span>
          </p>
          <br />
        </div>
        <CreateReportsModal />
      </div>
    </div>
  )
}
